/** Reads the network name format and returns readable properties.
 *  Format: networks/<id>-<net> i.e. networks/mina-mainnet */
export function readCbPayNetwork(name: string | null = '') {
  const split = name?.split(/[/-]+/) || '';
  return {
    id: split[1],
    networkType: split[2],
  };
}
